import clsx from 'classnames'
import { useRef, useState } from 'react'
import { MdSearch, MdClose } from 'react-icons/md'
import { useSpring, animated } from 'react-spring'

import styles from './index.module.css'

interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onFiltersClear?: () => void
}

export function SearchInput ({ value, className, style, onFocus, onBlur, onFiltersClear, ...rest }: SearchInputProps): JSX.Element {
  let [ isFocused, setIsFocused ] = useState(false)
  let inputRef = useRef<HTMLInputElement>(null)

  let iconStyles = useSpring({
    to: isFocused || (typeof value === 'string' && value.length > 0)
      ? { opacity: 0, transform: 'translateX(-2.125rem)' }
      : { opacity: 1, transform: 'translateX(0rem)' }
  })

  let inputWrapperStyles = useSpring({
    to: typeof onFiltersClear !== 'function'
      ? { width: 'calc(100% - 1.875rem)', maxWidth: 'calc(100% - 1.875rem)', minWidth: 'calc(100% - 1.875rem)' }
      : { width: 'calc(100% - 4.5rem)', maxWidth: 'calc(100% - 4.5rem)', minWidth: 'calc(100% - 4.5rem)' }
  })

  let inputStyles = useSpring({
    to: isFocused || (typeof value === 'string' && value.length > 0)
      ? { transform: 'translateX(-2rem)', width: 'calc(100% + 0rem)', maxWidth: 'calc(100% + 0rem)', minWidth: 'calc(100% + 0rem)' }
      : { transform: 'translateX(0rem)', width: 'calc(100% - 2rem)', maxWidth: 'calc(100% - 2rem)', minWidth: 'calc(100% - 2rem)' }
  })

  return (
    <div className={styles.wrapper}>
      <animated.div
        className={styles.inputWrapper}
        onClick={() => {
          inputRef.current?.focus()
        }}
        style={inputWrapperStyles}
      >
        <animated.div
          className={styles.icon}
          style={iconStyles}
        >
          <MdSearch
            size={24}
            color='#aaa'
          />
        </animated.div>

        <animated.input
          type='search'
          ref={inputRef}
          className={clsx(styles.input, className)}
          autoComplete='off'
          value={value}
          onFocus={event => {
            setIsFocused(true)
            onFocus?.(event)
          }}
          onBlur={event => {
            setIsFocused(false)
            onBlur?.(event)
          }}
          style={{
            ...style,
            ...inputStyles
          }}
          {...rest}
        />
      </animated.div>

      <animated.button
        type='button'
        className={styles.helperTextAnchor}
        onClick={onFiltersClear}
        title='Clear filters'
      >
        <MdClose
          color='#fff'
        />
      </animated.button>
    </div>
  )
}
